import { Button, useModal } from '@gsa/afp-component-library';
import CancelRequestModal from '../cancel-modal/cancel-request-modal';
import { useDispatch } from 'react-redux';
import { setSelectedCustomerAccount } from '../../../../reducers/additionals-reducer';
import { useCancelAdditionalsRequest } from '../../../../requests/additionals-request';
import { useSelector } from 'react-redux';
import useBackToList from '../../utils/use-back-to-list';

export default function AdditionalRequestActionButtons({
  disable,
  saveButton,
  cancelButton,
  nextFormId,
  hideButtons,
  submitButton,
  prevButton,
  returnToSearch,
  returnRequest,
  fillExistVehicle,
}) {
  const { additionalsDraftData } = useSelector(
    (state) => state.additionalsReducer,
  );
  const { backToList } = useBackToList();
  const [cancelRequest] = useCancelAdditionalsRequest();

  const cancelModal = useModal();
  const dispatch = useDispatch();

  if (!disable) disable = [];
  if (!hideButtons) hideButtons = [];

  return (
    <>
      <CancelRequestModal
        isOpen={cancelModal.isOpen}
        handleCancel={async () => {
          if (additionalsDraftData?.additionalRequestId) {
            await cancelRequest({
              variables: {
                additionalRequestId: additionalsDraftData?.additionalRequestId,
              },
            });
          }
          dispatch(setSelectedCustomerAccount({}));
          backToList();
        }}
        handleClose={cancelModal.closeModal}
      />
      <div className="vehicle-referral-action-buttons">
        {!hideButtons.includes('previous') && (
          <Button
            type="button"
            variant="outline"
            disabled={false}
            label="Previous"
            {...prevButton}
          />
        )}
        {!hideButtons.includes('returnToSearch') && (
          <Button
            type="button"
            variant="outline"
            disabled={false}
            label="Return to search"
            {...returnToSearch}
          />
        )}
        {!hideButtons.includes('cancel') && (
          <Button
            type="button"
            variant="secondary"
            onClick={() => {
              cancelModal.openModal();
            }}
            disabled={false}
            label="Cancel request"
            {...cancelButton}
          />
        )}
        {!hideButtons.includes('save') && (
          <Button
            type={'button'}
            variant="outline"
            onClick={() => {}}
            leftIcon={{
              name: 'save_alt',
            }}
            disabled={false}
            label="Save/exit"
            {...saveButton}
          />
        )}

        {!hideButtons.includes('returnRequest') && (
          <Button
            type="button"
            variant="secondary"
            onClick={() => {}}
            leftIcon={{ name: 'undo' }}
            disabled={disable.includes('returnRequest')}
            label={'Return to submitter'}
            {...returnRequest}
          />
        )}

        {!hideButtons.includes('fillExistVehicle') && (
          <Button
            variant="primary"
            onClick={() => {}}
            leftIcon={{ name: 'add' }}
            label={'Fill with existing vehicle'}
            type={'button'}
            {...fillExistVehicle}
          />
        )}

        {!hideButtons.includes('submit') && (
          <Button
            variant="primary"
            onClick={() => {}}
            leftIcon={{ name: 'check' }}
            disabled={disable.includes('submit')}
            label={'Save and submit'}
            type={nextFormId ? 'submit' : 'button'}
            form={nextFormId}
            {...submitButton}
          />
        )}
      </div>
    </>
  );
}
